<template>
  <div style="max-width:480px;">
    <div class="wxOauth-bg"></div>
    <div class="wxOauth-loading">
      <div>
        <img src="../../../static/wxOauth/wxOauthLoading.gif" class="wxOauth-img">
      </div>
      <div class="wxOauth-span"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";
export default {
  computed: {
    ...mapGetters(["g_UserInfo"])
  },
  data() {
    return {
      isWXBrowser: typeof WeixinJSBridge == "undefined" ? false : true,
      redirect: "https://i.998.com"
    };
  },
  activated() {
    var state = this.$route.query.state;
    if (state == undefined) {
      this.checkBind();
    } else {
      if (state == "TRUE") {
        window.alert("您已成功解绑！");
        this.$router.push({ path: "/checkWXBind" });
      } else if (state == "FALSE") {
        window.alert("您暂未绑定微信！");
        this.$router.push({ path: "/checkWXBind" });
      } else {
        window.alert("解除绑定失败，请重试！");
        this.$router.push({ path: "/home/index" });
      }
    }
  },
  methods: {
    checkBind() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/apis/Account/WXUnBind&response_type=code&scope=snsapi_base&state=STATE%23wechat_redirect";
    }
  }
};
</script>



<style lang="less" scope>
@import "../../assets/theme.less";
.wxOauth-bg {
  background-color: #000000;
  opacity: 0.6;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 480px;
}
.wxOauth-loading {
  position: absolute;
  margin-top: 3rem;
  width: 70%;
  left: 15%;
  background-color: #fff;
  border-radius: 4px;
  z-index: 999;
  opacity: 1;
  max-width: 336px;
}
.wxOauth-img {
  padding-top: 20px;
  padding-bottom: 20px;
  width: 70%;
  margin-left: 15%;
}
.wxOauth-span {
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
  color: #333333;
  font-size: 0.33rem;
  display: none;
}
</style>


// WEBPACK FOOTER //
// wxUnBind.vue?05518d00